import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { APP } from 'src/app/config/app';
import { IAvailabilities } from 'src/app/models';
import { ExpeditionStatus, UserRole } from 'src/app/models/enums';
import { IBulkActionType } from 'src/app/models/enums/bulkActionType';
import { LiteralService, StorageService } from 'src/app/services';
import { images } from 'src/images';
import { ActivatedRoute } from '@angular/router';
import { AVAILABILITY_FILTER_KEYS } from 'src/app/filters';

@Component({
  selector: 'app-availabilities-search-bar',
  templateUrl: './availabilities-search-bar.component.html',
  styleUrl: './availabilities-search-bar.component.scss',
  standalone: false
})
export class AvailabilitiesSearchBarComponent implements OnChanges, OnInit, OnDestroy {

  @Input() placeholder = '';
  @Input() embedded = false;
  @Input() searching: boolean = false;
  @Input() searchValue = '';
  @Input() availabilities: IAvailabilities[] = [];
  @Input() setupUrl = '';

  private queryParamsSub?: Subscription;
  @Output() filter = new EventEmitter();
  @Output() searchEventEmitter = new EventEmitter<string>();
  @Output() enableMultiselect = new EventEmitter<string>();
  @Output() onBulkAction = new EventEmitter();
  @Output() onChangePaginationSize = new EventEmitter<number>();
  @Output() onCreateDepartures = new EventEmitter<void>();

  public filterOpened = false;
  public filtersApplied = 0;
  public allowBulkEditing = true;

  public bulkActions = [
    {
      action: IBulkActionType.EDIT,
      label: 'availabilities.actions.edit.title',
      image: images.booking.actions.bulkSelect
    },
    {
      action: IBulkActionType.DELETE,
      label: 'availabilities.actions.delete.title',
      image: images.booking.actions.delete
    }
  ];
  
  public bulkSelectedAction = '';

  public images = images;

  public adminRole: UserRole;

  public rowsDisplayOpened = false;
  public rowsDisplayValue = APP.DEFAULT_PAGE_SIZE;
  public defaultRowsDisplay = APP.DEFAULT_PAGE_SIZE;

  public routeId: any;

  constructor(public literalService: LiteralService, private activatedRoute: ActivatedRoute, private storageService: StorageService) {}

  search(event: any) {
    this.searchEventEmitter.emit(event);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['searching'] && changes['searching'].currentValue) {
      this.bulkSelectedAction = '';
      this.enableMultiselect.emit('');
    }  
  }

  ngOnInit() {
    this.applyFromUrl();
    this.queryParamsSub = this.activatedRoute.queryParamMap.subscribe((params) => {
      this.routeId = params.get('routeId');
      this.applyFromUrl();
    });
  }

  ngOnDestroy(): void {
    this.queryParamsSub?.unsubscribe();
  }

  private applyFromUrl() {
    const params = this.activatedRoute.snapshot.queryParamMap;
    const sizeParam = params.get('size');
    const sizeFromUrl = sizeParam ? Number(sizeParam) : null;
    this.rowsDisplayValue = (sizeFromUrl && !isNaN(sizeFromUrl) && sizeFromUrl > 0)
      ? sizeFromUrl
      : this.defaultRowsDisplay;
    this.filtersApplied = AVAILABILITY_FILTER_KEYS.reduce(
      (count, key) => count + (params.get(key) !== null ? 1 : 0),
      0
    );
  }

  onActionChange(action: string) {
    this.bulkSelectedAction = action;
    this.enableMultiselect.emit(action);
  }

  updateNumberOfElements(event: number) {
    this.rowsDisplayOpened = false;
    this.rowsDisplayValue = event > 0 ? event : this.defaultRowsDisplay;
    this.storageService.setAvailabilitiesPageSize(this.rowsDisplayValue);
    this.onChangePaginationSize.emit(event);
  }

  showActionButton(action: string) {
    return this.bulkSelectedAction === action && this.availabilities.filter((availability) => availability.selected).length > 0;
  }

  applyFilter(event: { selectedStatus: ExpeditionStatus[], bookings?: boolean, fromDate?: Date, toDate?: Date, startTime?: string, endTime?: string }) {
    this.filter.emit(event);
    this.filterOpened = false;
  }

}
